// extracted by mini-css-extract-plugin
module.exports = {"animation":"mini-product-card_animation__zE0vO","skeletonShimmer":"mini-product-card_skeletonShimmer__zKIAY"};